module.exports = __webpack_public_path__ + "static/kovka9-7ccb8efc5d7bdaa765331185673a85aa.png";